import { RefreshCw } from 'lucide-react';

import type { PositionDto } from '../../lib/api/endpoints';
import { relativeTimestamp } from '../../lib/format/date';

type PricesAsOfProps = {
  positions: readonly Pick<PositionDto, 'priceSource' | 'priceFetchedAt' | 'priceStale'>[];
  refreshing: boolean;
};

export function PricesAsOf({ positions, refreshing }: PricesAsOfProps) {
  if (positions.length === 0) return null;

  const quoted = positions.filter((position) => position.priceSource !== 'last-fill');
  const lastFillCount = positions.length - quoted.length;
  const newest = quoted.reduce<string | null>((latest, position) => {
    if (!position.priceFetchedAt) return latest;
    return latest === null || position.priceFetchedAt > latest ? position.priceFetchedAt : latest;
  }, null);
  const stale = positions.some((position) => position.priceStale);

  return (
    <p
      className="flex flex-wrap items-center gap-x-2 text-xs tabular-nums text-text-muted"
      role="status"
      aria-live="polite"
    >
      <span>{newest ? `Prices as of ${relativeTimestamp(newest)}` : 'No live prices yet'}</span>
      {lastFillCount > 0 ? <span>{lastFillCount} on last fill</span> : null}
      {stale ? <span className="text-warn">Some prices stale</span> : null}
      {refreshing ? (
        <span className="inline-flex items-center gap-1">
          <RefreshCw className="h-3 w-3 animate-spin" aria-hidden="true" />
          Refreshing...
        </span>
      ) : null}
    </p>
  );
}
